<div *ngIf="components$ | async as components">
    <ng-container *ngIf="components.length>0">
        <h3>Technical</h3>
        <div class="equipment-section-border ">
            <ng-container *ngFor="let component of components">   
                <base-component [type]="component.type" [data$]="component.data$"></base-component>
            </ng-container>
        </div>
    </ng-container>
</div>
